import { Base, Component, Prop } from '@/vue-property-decorator'
import { createSvgSprite } from '@/utils/business-utils/assets'
import style from './style.module.scss'
/** 收藏图标 后面可能要扩展出未收藏和已收藏两种状态,后面再说*/
type Props = {
  /** 图标是否禁用点击 */
  forbidClick?: boolean
  /** 图标类型: [star:星形图形] [circle:圆形图标] [heart:心形图标] [block 方形]  */
  type?: 'star' | 'circle' | 'heart' | 'block'
  /** 收藏状态 */
  isFavorited?: boolean
  /** 尺寸 default:默认 small:小的 */
  mySize?: 'default' | 'small'
  /**使用动画 */
  useAnimate?: boolean
}
type Events = {
  onClick: (event: Props['isFavorited']) => void
}
/** 收藏图标映射 */
const favorIconMapper = {
  /** HK定制独有 */
  heart_true: '/lobby_asset/{layout}-{bg}-{skin}/web/home/icon_dt_sc1.png',
  /** 心形-收藏动效 */
  heart_animation: '',
  /** 心形-未收藏 */
  heart_false: '/lobby_asset/{layout}-{bg}-{skin}/common/home/icon_dt_sc.png'
}

interface State {
  /** 图标是否展示动画 */
  animation: boolean
}
@Component<FavoriteIcon>({
  name: 'FavoriteIcon'
})
export default class FavoriteIcon extends Base<State, Props, Events> {
  @Prop({ default: false })
  private forbidClick?: Required<Props>['forbidClick']
  @Prop({ default: 'circle' })
  private type!: Required<Props>['type']
  @Prop({ default: false })
  private isFavorited!: Required<Props>['isFavorited']
  @Prop({ default: true })
  private useAnimate!: Required<Props>['useAnimate']
  state: State = {
    animation: false
  }
  @Prop({ default: 'default' })
  private mySize!: Required<Props>['mySize']
  /** 当前显示的收藏图标 */
  get favorIcon() {
    const { type, isFavorited, useAnimate } = this
    const mapKey = `${type}_${
      useAnimate && isFavorited && this.state.animation
        ? 'animation'
        : isFavorited
    }` as keyof typeof favorIconMapper
    return favorIconMapper[mapKey]
  }

  render() {
    const { forbidClick, type, isFavorited, mySize } = this
    return (
      <div
        class={{
          [style[`favorited-icon`]]: true,
          [style[`type-${type}`]]: true,
          [style[`size-${mySize}`]]: true
        }}
        onClick={(event) => {
          event.stopPropagation()
          this.setState({
            animation: !isFavorited
          })
          if (forbidClick) return
          this.$emit('click', this.isFavorited)
        }}
      >
        {/* 使它的实际点击区域比图标要大一点点 */}
        <div class={style['click-area']}></div>
        <icon-sprite
          class={{ [style.isFavorited]: isFavorited }}
          sprite={createSvgSprite('icon_dt_sc2')}
        />
      </div>
    )
  }
}
